// extracted by mini-css-extract-plugin
export default {"divider":"styles_divider__SbR9G","footer":"styles_footer__2KyTa","button":"styles_button__RYOcD"};